<template>
  <div>
    <!--Header Components-->
    <base-header class="mt-4 pb-6" type="" />
    <b-container fluid class="mt--6">
      <div>
        <loading :active="loadingCounter > 0" color='#007bff' :width='128' :height='128' loader='dots' :can-cancel="true" is-full-page />
      </div>
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0">
                <b-row>
                  <b-col cols="10">
                      <!-- <h3>{{title}}</h3> -->
                      <div>
                        <span style="font-weight: bold">{{title}}</span>
                        &nbsp;
                        <!-- tick -->
                        <i class="fas fa-check-circle text-green fa-lg" v-if="doc.is_approved == 1"></i>
                        &nbsp;
                        <!-- red -->
                        <i class='fas fa-ban' style='font-size:20px;color:red' v-if="doc.is_approved == 0"></i>
                        &nbsp;
                        <!-- printe logo-->
                        <i class="fas fa-print text-blue fa-lg" v-if="doc.is_printed == 1"></i>
                        &nbsp;
                      </div>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col md="2">
                  <base-input :label="language_terms['DATE']">
                    <flat-picker slot-scope="{focus, blur}"
                      v-model="doc.date"
                      :disabled="!is_editing"
                      @on-open="focus" @on-close="blur" style="background-color: white;" class="form-control datepicker">
                    </flat-picker>
                  </base-input>
                </b-col>
                <b-col md="2">
                  <base-input :label="language_terms['TYPE']">
                    <el-select filterable clearable v-model="doc.is_assembled" :disabled="!is_editing">
                        <el-option
                            v-for="item in assembly_options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                  </base-input>
                </b-col>
                <b-col md="8">
                  <base-input :label="language_terms['REMARKS']" v-model="doc.remarks" :disabled="!is_editing"> </base-input>
                </b-col>
              </b-row>
            </card>
            <card>
              <b-row v-if="id = '_new' && is_editing">
                <b-col md="7">
                    <base-input :label="language_terms['PRODUCT']">
                        <multiselect
                            @search-change="asyncFindProduct"
                            v-model="selectedProduct"
                            @input="onSelectProduct"
                            :disabled="!is_editing"
                            :internalSearch = "false" ref="multiselcetRef" label="name" track-by="id" placeholder="Type to search" open-direction="bottom" :preserve-search="false" :options="products" :multiple="false" 
                            :searchable="true" :clear-on-select="false" :close-on-select="true" :options-limit="300" :limit="50" :limit-text="limitText" :max-height="600" :show-no-results="false" :hide-selected="false"
                        />
                    </base-input>
                </b-col>
                <b-col md="2">
                  <base-input v-model="item.qty" :label="language_terms['QTY']" type="number" :disabled="!is_editing"></base-input>
                </b-col>
                <b-col md="2">
                  <base-input :label="language_terms['ONHAND_QTY']" :value="(item.qty_existing * 1).toLocaleString('en-US', {minimumFractionDigits:0, maximumFractionDigits:0})" disabled />
                </b-col>
                <!-- <b-col md="2">
                  <base-input :label="language_terms['COST_BEFORE_IMPAIRMENT']" :value="(item.old_unit_cost *1).toLocaleString('en-US', {minimumFractionDigits:4, maximumFractionDigits:4})" disabled />
                </b-col> -->
                <b-col md="1" class="mt-4" v-if="doc.items.length == 0">
                    <b-button variant="primary" @click="onClickAdd()" class="mt-2" v-if="is_editing">{{language_terms['ADD']}}</b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" v-if="doc.items.length > 0">
                  <b-table-simple hover responsive>
                    <b-thead head-variant="light">
                      <b-th>{{language_terms['SNO']}}</b-th>
                      <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                      <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                      <b-th>{{language_terms['QTY']}}</b-th>
                      <b-th v-if="id == '_new' && is_editing">{{language_terms['ONHAND_QTY']}}</b-th>
                      <b-th v-if="id != '_new'">Unit Cost (S$)</b-th>
                      <b-th v-if="id != '_new'">Components</b-th>
                      
                      <b-th></b-th>
                    </b-thead>
                    <b-tbody>
                      <tr v-for="(item, index) in doc.items" :key="index">
                        <td>{{index + 1}}</td>
                        <td>{{item.product_code}}</td>
                        <td>{{item.product_name}}</td>
                        <td>{{(item.qty * 1).toLocaleString('en-US', {minimumFractionDigits:0, maximumFractionDigits:0})}}</td>
                        <td v-if="id == '_new' && is_editing">{{(item.qty_existing * 1).toLocaleString('en-US', {minimumFractionDigits:0, maximumFractionDigits:0})}}</td>
                        <td v-if="id != '_new'">{{(item.unit_cost_home * 1).toLocaleString('en-US', {minimumFractionDigits:0, maximumFractionDigits:4})}}</td>
                        <td v-if="id != '_new'">{{ item.components_count }}</td>
                        <td><base-button size="sm" icon type="danger" @click="deleteItem(index)" v-if="is_editing"><i class="fas fa-trash-alt"></i></base-button></td>
                      </tr>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
                <div class="floating-bar"  v-if="doc.items.length > 0 && is_editing">
                    <div class="floating-bar-container" align="center">
                        <b-button-group>
                            <b-button class="transparent-btn" @click="onClickSave()" v-if="id = '_new' && is_editing">
                                <i class="fas fa-save mr-2 text-success"></i>{{language_terms['SAVE']}}
                            </b-button>
                            <!-- <b-button class="transparent-btn" @click="onClickEdit()" v-if="id != '_new' && !is_editing && doc.is_approved == null">
                                <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                            </b-button> -->
                            <b-button class="transparent-btn"  @click="onClickCancel()" v-if="id = '_new' && is_editing">
                                <i class="fas fa-times mr-2 text-danger"></i>{{language_terms['CANCEL']}}
                            </b-button>
                            <!-- <b-button class="transparent-btn" @click="onClickApprove()" v-if="id != '_new' && !is_editing && doc.is_approved == null">
                                <i class="fas fa-save mr-2 text-info"></i>{{language_terms['APPROVE']}}
                            </b-button>
                            <b-button class="transparent-btn"  @click="onClickReject()" v-if="id != '_new' && !is_editing && doc.is_approved == null">
                                <i class="fas fa-times mr-2 text-danger"></i>{{language_terms['REJECT']}}
                            </b-button>
                            <b-button class="transparent-btn" @click="onClickPrint()" v-if="id != '_new' && !is_editing">
                                <i class="fa fa-print mr-2 text-primary"></i>{{language_terms['PRINT']}}
                            </b-button> -->
                        </b-button-group>
                    </div>
                </div>
              </b-row>
            </card>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>
<script>
import moment from 'moment';
import productLookup from "@/components/Autocomplete.vue";
import { Select, Option } from 'element-ui';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState } from "vuex";
import axios from "axios";
import { apiRoutes } from "../../../apiRoutes";
import { authHeader } from "../../../global";
import PaginatedTables from '@/views/Tables/PaginatedTables';
import Vue from 'vue'

export default {
  components: {
    productLookup,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
  computed: {
    ...mapState({
      language_terms: state => state.languages.language_terms,
      selected_lang: state => state.languages.selected_langauge,

    }),
  },
  data() {
    return {
      title:null,
      loadingCounter:0,
      id:null,
      is_editing:0,
      fullPage: true,
      assembly_options:[
        {
            label: "Assembly",
            value: '1'
        },
        {
            label: "Disassembly",
            value: '0'
        },
      ],
      doc: {
        id:null,
        items: [],
        date:moment().format("YYYY-MM-DD"),
        qty:null,
        remarks:null,
        is_assembled:'1',
      },
      item: {
        id:null,
        product_id: null,
        product_code:null,
        product_name: null,
        unit_cost: null,
        qty_existing: null,
        old_unit_cost:null,
      },
      products:[],
      selectedProduct:null,
    }
  },

  async mounted() {
      let id = this.$route.params.id
      if(id == '_new')
        {
            this.title = this.language_terms['NEW_BOM_ASSEMBLY']
            this.is_editing = true
        }
      else
        {
            await this.retrieve(id)
            this.title = this.language_terms['BOM_ASSEMBLY'] + ' ' + [id]
            this.is_editing = false
        }
    },

  methods: {
    async onClickReject()
    {
      let code = this.$route.params.id
      let payload = {code:code}
      await axios.post(apiRoutes["STOCKIMPAIRMENTS_REJECT"], payload, authHeader()).then((response) => {
        if (response.data.code == 1) {
          this.doc.items = response.data.data
          Vue.notify({text: 'Stock' + " has been rejected!", group: 'notify', type: 'success', max: 5, duration: 5000,speed: 300})
          this.$router.push("/inventory/stock-impairments")
        } else {
          this.doc.items = [];
        }
      })
        .catch((error) => {
          if (error.response) {
            Vue.notify({ group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300, });
          }
        });
    },

    async onClickPrint()
    {
      let code = this.$route.params.id
      let payload = {code:code}
      await axios.post(apiRoutes["STOCKIMPAIRMENTS_PRINT"], payload, authHeader()).then((response) => 
      {
        if (response.data.code == 1) {
          let url =  'https://reports.unityerp.com/esteam/stock-impairment/' +  encodeURIComponent(localStorage.getItem('access_token')) + '/' + encodeURIComponent(code);
          window.open(url);            
        } 
        else 
        {
          alert('Failed');
        }

      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });
    },

    async onClickApprove()
    {
      let code = this.$route.params.id
      let payload = {code:code}
      await axios.post(apiRoutes["STOCKIMPAIRMENTS_APPROVE"], payload, authHeader()).then((response) => {
        if (response.data.code == 1) {
          this.doc.items = response.data.data
          Vue.notify({text: 'Stock' + " has been approved!", group: 'notify', type: 'success', max: 5, duration: 5000,speed: 300})
          this.$router.push("/inventory/stock-impairments")
        } else {
          this.doc.items = [];
        }
      })
        .catch((error) => {
          if (error.response) {
            Vue.notify({ group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300, });
          }
        });
    },
    
    async onClickEdit()
    {
      this.is_editing = true
    },

    async retrieve(code)
    {
      this.loadingCounter++
        let payload = {code:code}
        await axios
        .post(apiRoutes["BOMASSEMBLIES_RETRIEVE"], payload, authHeader())
        .then((response) => 
        {
          if (response.data.code == 1) {
            this.doc = response.data.data
          } 
          else 
          {
            alert('Failed');
          }

        })
        .catch((error) => {
          if (error.response) {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          }
        });
        this.loadingCounter--
    },

    async onSelectProduct(row)
    {
      if (row != null)
      {
        this.selectedProduct = row;
        this.item.product_id = row.id;
        this.item.product_name = row.name;
        this.item.product_code = row.code;


        this.item.qty_existing = null
        this.item.old_unit_cost = null
          if (row.name != null)
          {
            this.item.qty_existing = row.qty_onhand
            this.item.old_unit_cost = (row.avg_unit_cost * 1 ).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})
          }
      }

    },
    async onClickAdd()
    {
      let date = this.doc.date
      if (date == null || date == '')
        {
            Vue.notify({group: 'notify', type: 'error', text: 'Date has to be selected', max: 5, duration: 5000, speed: 300})
        }
        else if (this.selectedProduct == null || this.selectedProduct == '')
        {
            Vue.notify({group: 'notify', type: 'error', text: 'Product has to be selected', max: 5, duration: 5000, speed: 300})
        }
        else if (this.item.qty == null || this.item.qty == '')
        {
            Vue.notify({group: 'notify', type: 'error', text: 'Amount has to be entered', max: 5, duration: 5000, speed: 300})
        }
        else
        {
          let item = {
            product_id: this.item.product_id,
            product_code: this.item.product_code,
            product_name: this.item.product_name,
            qty: this.item.qty,
            qty_existing: this.item.qty_existing,
          }
          this.doc.items.push(item);
              
          this.item.unit_cost = null;
        }
    },
    async deleteItem(index)
    {
      this.doc.items.splice(index, 1);

    },

    limitText(count) {
      return `and ${count} others`;
    },
    async asyncFindProduct(query) 
    {
      let payload = { value: query, is_bom:1 };
      await axios.post(apiRoutes["PRODUCT_LOOKUP"], payload, authHeader()).then((response) => {
        if (response.data.code == 1) {
          this.products = response.data.data;
        } else {
          this.products = [];
        }
      })
        .catch((error) => {
          if (error.response) {
            Vue.notify({ group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300, });
          }
        });
    },

    async onClickSave()
    {
      if (this.$route.params.id == '_new')
      {
        let payload = {
        id:null,
        date:this.doc.date,
        is_assembled:this.doc.is_assembled,
        remarks:this.doc.remarks,
        items:this.doc.items,
      }
      await axios.post(apiRoutes["BOMASSEMBLIES_SAVE"], payload, authHeader()).then((response) => {
        if (response.data.code == 1) {
          this.doc.items = response.data.data
          let msg = ''

          if (this.doc.is_assembled == 1)
            msg = 'BOM Assembly created'
          else
            msg = 'BOM Disassembly created'
          Vue.notify({text: msg, group: 'notify', type: 'success', max: 5, duration: 5000,speed: 300})
          this.$router.push("/inventory/bom-assemblies")
        } else {
          this.doc.items = [];
        }
      })
        .catch((error) => {
          if (error.response) {
            Vue.notify({ group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300, });
          }
        });
      }
      else
      {
        let payload = {
        id:this.doc.id,
        date:this.doc.date,
        remarks:this.doc.remarks,
        time_created:this.doc.time_created,
        item:this.doc.items,
      }
      await axios.post(apiRoutes["STOCKIMPAIRMENTS_UPDATE"], payload, authHeader()).then((response) => {
        if (response.data.code == 1) {
          this.doc.items = response.data.data
          Vue.notify({text: 'Stock' + " has been adjusted!", group: 'notify', type: 'success', max: 5, duration: 5000,speed: 300})
          this.$router.push("/inventory/stock-impairments")
        } else {
          this.doc.items = [];
        }
      })
        .catch((error) => {
          if (error.response) {
            Vue.notify({ group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300, });
          }
        });
      }
      
    },

    async onClickCancel()
    {
      let url = '/inventory/stock-impairments'
      this.$router.push(url)
    },
  }
}
</script>
